export const EBOOK_ROOT_PATHS = {
  cs: '/ebooks',
  en: '/ebooks',
  pl: '/ebooks'
};

export const SUPPORTED_EBOOK_LOCALES = Object.keys(EBOOK_ROOT_PATHS);

export function getEbookRootForLocale(locale) {
  return EBOOK_ROOT_PATHS[locale] || EBOOK_ROOT_PATHS.cs;
}

export function isEbookRoot(rootPath, locale) {
  return rootPath === getEbookRootForLocale(locale);
}

export function getEbookUrl(slug, locale) {
  const root = getEbookRootForLocale(locale);
  const prefix = locale === 'cs' ? '' : `/${locale}`;
  return `${prefix}${root}/${slug}`;
}

export function extractEbookSlug(restOfPath) {
  if (!restOfPath) return null;
  const trimmed = restOfPath.replace(/^\/+/, '').replace(/\/+$/, '');
  if (!trimmed) return null;
  const segments = trimmed.split('/');
  return segments[0] || null;
}
